import React from "react";
import StackedContent from "@/components/StackedContent/StackedContent";
import { Image } from "react-bootstrap";
import Button from "@/components/Button/Button";
import { RedirectIcon } from "@/components/MenusIcons/MenusIcons";

interface GettingStartedSectionProps {
  header: string;
  description: React.ReactNode; 
  media: string;                
  buttonText?: string;          
  linkUrl?: string;     
}

const GettingStartedSection: React.FC<GettingStartedSectionProps> = ({
  header,
  description,
  media,
  buttonText,
  linkUrl,
}) => {
  return (
    <StackedContent>
      <StackedContent.Col1 cols="4" desktopOrder="2">
        <Image src={media} fluid alt="Getting started OLS" />
      </StackedContent.Col1>

      <StackedContent.Col2 cols="6" desktopOrder="1">
        <h2 className="color-primary">{header}</h2>
        <p className="body-m">{description}</p>
        {buttonText && linkUrl && (
          <div className="btn-section">
            <Button
              label={buttonText}
              icon={<RedirectIcon />}
              iconPosition="after"
              size="lg"
              variant="fill"
              width="fit-content"
              linkUrl={linkUrl}
              linkTarget="_blank"
            />
          </div>
        )}
      </StackedContent.Col2>
    </StackedContent>
  );
};

export default GettingStartedSection;
